import { MiaPlaza } from "@/Reinforced.Typings";
import pDefer from "p-defer";
import { defineStore, type Store } from 'pinia';

export interface State {
	isButtonShown: boolean;
	scopeAndSequenceLinks: Record<MiaPlaza.Model.Subject, string>;
}

export interface Getters {
	IsSidebarButtonShown(): boolean;
}

export interface Actions {
	GetSubjectLink(selectedSubject: MiaPlaza.Model.Subject): string | [MiaPlaza.Model.Subject, string] | undefined;
	SetVisibilityOfSidebarButton(visibility: boolean): void;
}

export type ScopeAndSequenceStore = Store<string, State, Getters, Actions>;

const STORE_NAME = 'scope-and-sequence-store';

const scopeAndSequenceStore = pDefer<ScopeAndSequenceStore>();

export function defineScopeAndSequenceStore(scopeAndSequenceLinks: Record<MiaPlaza.Model.Subject, string>): ScopeAndSequenceStore {
	const store = defineStore(STORE_NAME, {
		state: (): State => ({
			isButtonShown: false,
			scopeAndSequenceLinks
		}),
		actions: {
			GetSubjectLink(selectedSubject: MiaPlaza.Model.Subject) {
				return Object.entries(this.scopeAndSequenceLinks)
					.find((scopeAndSequenceLink) => scopeAndSequenceLink[0] === selectedSubject)
					?.pop();
			},
			SetVisibilityOfSidebarButton(visibility: boolean) {
				this.isButtonShown = visibility;
			}
		},
		getters: {
			IsSidebarButtonShown: (state) => {
				return state.isButtonShown;
			}
		}
	})();

	scopeAndSequenceStore.resolve(store);
	return store;
}

export function useScopeAndSequenceStore(): Promise<ScopeAndSequenceStore> {
	return scopeAndSequenceStore.promise;
}
